import type { FoodField as IFoodField, FoodItem, FoodKind } from './contracts';

export class FoodField implements IFoodField {
  readonly items: FoodItem[] = [];
  private nextId = 1;

  spawn(x: number, z: number, amount: number, value = 5, kind: FoodKind = 'pile'): number {
    const id = this.nextId++;
    this.items.push({ id, x, z, amount, value, kind });
    return id;
  }

  tryPickup(x: number, z: number, grabRadius: number): FoodItem | undefined {
    const r2 = grabRadius * grabRadius;
    for (let i = 0; i < this.items.length; i++) {
      const it = this.items[i];
      if (it.amount <= 0) continue;
      const dx = it.x - x;
      const dz = it.z - z;
      if (dx * dx + dz * dz <= r2) {
        it.amount -= 1;
        return it;
      }
    }
    return undefined;
  }

  /** Zero out every pile whose centre falls within `radius` of (cx, cz). The
   *  lawnmower uses this to vacuum up food it rolls over. */
  consumeArea(cx: number, cz: number, radius: number): number {
    const r2 = radius * radius;
    let n = 0;
    for (let i = 0; i < this.items.length; i++) {
      const it = this.items[i];
      if (it.amount <= 0) continue;
      const dx = it.x - cx;
      const dz = it.z - cz;
      if (dx * dx + dz * dz > r2) continue;
      it.amount = 0;
      n++;
    }
    return n;
  }
}
